import { useAtomValue, useSetAtom } from "jotai";
import { useReactFlow } from "@xyflow/react";
import { nodesAtom, edgesAtom, zslAtom } from "@zapier/canvas-state";
import { validateZSL } from "../Composer/validateZSL";
import { Composer } from "../Composer/Composer";
import { parseCanvasDataFromZSL } from "@zapier/streaming/src/utils/zslToCanvas";

type Props = {
  onClose?: () => void;
};

export function CanvasComposer({ onClose }: Props) {
  const { fitView } = useReactFlow();
  const setNodes = useSetAtom(nodesAtom);
  const setEdges = useSetAtom(edgesAtom);
  const zsl = useAtomValue(zslAtom);
  const setZsl = useSetAtom(zslAtom);

  const handleZslToCanvas = async (zsl: any) => {
    try {
      const nodesAndEdges = await parseCanvasDataFromZSL(zsl);
      setZsl(zsl);
      if (nodesAndEdges) {
        const {
          canvas: { nodes, edges },
        } = nodesAndEdges;
        setNodes(nodes);
        setEdges(edges as any);
        fitView();
      }
    } catch (error) {
      console.error("Error converting ZSL to Canvas:", error);
    }
  };
  return (
    <Composer
      orchestratorHost="canvas"
      onClose={onClose}
      onToolCall={async ({ toolCall }) => {
        if (toolCall.toolName === "update_ui") {
          await handleZslToCanvas(toolCall.args);
          const validationResult = await validateZSL(toolCall.args as any);

          if (!validationResult.valid) {
            const warningMessage =
              validationResult.errorMessage || "Validation failed";
            (toolCall as any).warningMessage = warningMessage;

            return {
              toolCallId: toolCall.toolCallId,
              result: {
                content: [
                  {
                    type: "text",
                    text: `Canvas updated but validation failed.\n${warningMessage}`,
                  },
                ],
              },
            };
          } else {
            (toolCall as any).isValidationSuccess = true;
            return {
              toolCallId: toolCall.toolCallId,
              result: {
                content: [{ type: "text", text: "Canvas updated" }],
              },
            };
          }
        }
        throw new Error(`Unhandled tool call: ${toolCall.toolName}`);
      }}
      additionalData={{
        ...(zsl && { zsl: JSON.stringify(zsl) }),
      }}
    />
  );
}

export default CanvasComposer;
